import { render, staticRenderFns } from "./InputChip.vue?vue&type=template&id=43b31971"
import script from "./InputChip.vue?vue&type=script&lang=js"
export * from "./InputChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports